export const RESULTADOS = {
  EXCELENTE: 'Excelente',
  SATISFACTORIO: 'Satisfactorio',
  INSATISFACTORIO: 'Insatisfactorio',
}
